import { render, staticRenderFns } from "./TetrisGame.vue?vue&type=template&id=cd006406&scoped=true"
import script from "./TetrisGame.vue?vue&type=script&lang=js"
export * from "./TetrisGame.vue?vue&type=script&lang=js"
import style0 from "./TetrisGame.vue?vue&type=style&index=0&id=cd006406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd006406",
  null
  
)

export default component.exports